<div>
	<div [ngClass]="{'modal--show': modalOpen, 'modal--hide': !modalOpen}" class="modal">

		<div class="modal-background"></div>

		<div class="modal-container">
			<h1 class="modal-title">Cookie settings</h1>

			<p i18n="More Information@@cookie.banner.modal.information.message">
				For more information about the cookies, or to update your preferences, please read our Cookie Policy
			</p>

			<div class="modal-content">
				<label class="cookie-checkbox-list_label">
					<input checked disabled type="checkbox" />

					<span class="checkbox-icon">
						<svg class="icon-check" height="12" viewBox="0 0 14 12" width="14">
							<use xlink:href="/images/icons/svg-sprite.svg#check"></use>
						</svg>
					</span>

					<span class="cookie-checkbox-list-item_name"
					      i18n="Essential Cookies@@cookie.banner.modal.essential.cookies">
							Essential Cookies (required)
					</span>

					<p i18n="Essential Cookies Message@@cookie.banner.modal.essential.cookies.message">
						These cookies are necessary for the website to function and cannot be switched off in our
						systems. They are usually only set in response to actions made by you which amount to a request
						for services, such as setting your privacy preferences, logging in or filling in forms.
					</p>
				</label>

				<label class="cookie-checkbox-list_label">
					<input (click)="toggleAnalyticsCookies()" [checked]="analyticsCookies" type="checkbox" />

					<span class="checkbox-icon">
						<svg class="icon-check" height="12" viewBox="0 0 14 12" width="14">
							<use xlink:href="/images/icons/svg-sprite.svg#check"></use>
						</svg>
					</span>

					<span class="cookie-checkbox-list-item_name"
					      i18n="Analytics Cookies@@cookie.banner.modal.analytics.cookies">
						Analytics Cookies
                    </span>

					<p i18n="Analytics Cookies Message@@cookie.banner.modal.analytics.cookies.message">
						We use analytics cookies to help us understand how users interact with our website.
					</p>
				</label>

				<label class="cookie-checkbox-list_label">
					<input (click)="toggleMarketingCookies()" [checked]="marketingCookies" type="checkbox" />

					<span class="checkbox-icon">
						<svg class="icon-check" height="12" viewBox="0 0 14 12" width="14">
							<use xlink:href="/images/icons/svg-sprite.svg#check"></use>
						</svg>
					</span>

					<span class="cookie-checkbox-list-item_name"
					      i18n="Marketing Cookies@@cookie.banner.modal.marketing.cookies">
						Marketing Cookies
                    </span>

					<p i18n="Marketing Cookies Message@@cookie.banner.modal.marketing.cookies.message">
						We use marketing cookies to help us improve the relevancy of advertising campaigns you receive.
					</p>
				</label>
			</div>

			<div class="button-bar button-bar--right button-bar--mobile-block">
				<button (click)="acceptSelectedCookies()"
				        class="button theme-btn-primary"
				        i18n="Save cookie preferences@@cookie.banner.modal.save.cookies"
				        type="button">
					Save cookie preferences
				</button>
			</div>
		</div>
	</div>
</div>
